var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowThickDownAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A3E0",
    d: "m6.52345,13.15358l-4.24667,-4.68748c-0.14071,-0.15532 -0.22588,-0.39035 -0.22588,-0.58772c0,-0.19737 0.08517,-0.43241 0.22588,-0.58772c0.30118,-0.33245 0.76372,-0.33245 1.0649,0l2.95588,3.26272l0,-9.37143c0,-0.49025 0.31419,-0.83705 0.75834,-0.83705c0.44414,0 0.75833,0.3468 0.75833,0.83705l0,9.37143l2.95588,-3.26272c0.30118,-0.33245 0.76368,-0.33245 1.06488,0c0.3012,0.33244 0.3012,0.843 0,1.17544l-4.24664,4.68748c-0.04403,0.0486 -0.0785,0.0724 -0.13875,0.1057c-0.01938,0.0106 -0.0203,0.0113 -0.0205,0.0115l-0.08893,0.0607c-0.19216,0.0707 -0.39091,0.0773 -0.55009,0.0098c-0.09761,-0.0124 -0.15469,-0.0641 -0.26663,-0.1877z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThickDownAlt);
export default __webpack_public_path__ + "static/media/arrow-thick-down-alt.3f532b08017767f64c0811ac8be06a4d.svg";
export { ForwardRef as ReactComponent };